import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';


export default function CorporateWebsiteDevelopment() {
  return (
      <>
    <SEO title="Corporate Website Development" />
    <div className="max-w-6xl mx-auto px-4 py-10 space-y-14">
      {/* Page Title */}
      <section className="text-center">
        <h1 className="text-4xl font-bold text-[#ff9b00] mb-4">
          Corporate Website Design
        </h1>
        <p className="text-lg text-gray-600 max-w-3xl mx-auto">
          Build a professional online presence that reflects your brand’s values, vision, and professionalism. Our corporate website designs establish trust and credibility with your audience.
        </p>
      </section>

      {/* Why Corporate Website Design */}
      <section className="grid md:grid-cols-2 gap-8 items-center">
        <div>
          <h2 className="text-2xl font-semibold text-[#ff9b00] mb-4">
            Why Invest in a Corporate Website?
          </h2>
          <ul className="space-y-3 text-gray-700 list-disc list-inside">
            <li>Builds brand authority and business credibility</li>
            <li>Creates a centralized platform for communication</li>
            <li>Supports investor and client relations</li>
            <li>Optimized for speed, SEO, and scalability</li>
          </ul>
        </div>
        <img
          src="/assets/corporate-website.svg"
          alt="Corporate website illustration"
          className="w-full max-w-md mx-auto"
        />
      </section>

      {/* Key Features */}
      <section>
        <h2 className="text-2xl font-semibold text-[#ff9b00] text-center mb-8">
          What We Offer
        </h2>
        <div className="grid md:grid-cols-3 gap-6">
          <FeatureCard
            title="Professional Branding"
            desc="Visually aligned with your brand identity and business objectives."
          />
          <FeatureCard
            title="Responsive Layout"
            desc="Fully optimized for desktop, tablet, and mobile devices."
          />
          <FeatureCard
            title="SEO & Performance"
            desc="Built with best practices for search engine visibility and fast loading speeds."
          />
        </div>
      </section>

      {/* Our Process */}
      <section>
        <h2 className="text-2xl font-semibold text-[#ff9b00] text-center mb-8">
          Our Design Process
        </h2>
        <div className="grid md:grid-cols-4 gap-6 text-center">
          {[
            'Business Requirement Analysis',
            'Wireframing & UI Mockups',
            'Custom Design & Development',
            'Testing & Go-Live',
          ].map((step, index) => (
            <div
              key={index}
              className="p-5 border rounded-lg shadow-sm bg-white hover:shadow-md transition"
            >
              <span className="text-3xl font-bold text-[#ff9b00]">{index + 1}</span>
              <p className="mt-2 text-gray-700">{step}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Call to Action */}
      <section className="text-center bg-[#ff9b00] text-white py-10 rounded-xl shadow-md">
        <h3 className="text-2xl font-bold mb-3">
          Ready to Design Your Corporate Website?
        </h3>
        <p className="mb-5">
          Let us help you create a trusted, professional online identity for your brand.
        </p>
        <Link
          to="/contact-us"
          className="inline-block bg-white text-[#ff9b00] px-6 py-2 rounded-full font-medium hover:bg-orange-100 transition"
        >
          Get Started Today
        </Link>
      </section>
    </div>
    </>
  );
}

// Feature Card Component
function FeatureCard({ title, desc }) {
  return (
    <div className="p-5 border rounded-xl bg-white shadow-sm hover:shadow-md transition">
      <h3 className="text-xl font-semibold text-[#ff9b00] mb-2">{title}</h3>
      <p className="text-gray-600">{desc}</p>
    </div>
  );
}
